import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = {
  key: 0,
  class: "text-catering-ink-500"
}
const _hoisted_3 = { class: "mb-1 text-catering-ink-900" }
const _hoisted_4 = { class: "rounded bg-catering-honey-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-honey-600" }
const _hoisted_5 = { class: "text-catering-ink-700" }
const _hoisted_6 = { class: "mb-1 break-words font-semibold text-catering-ink-900" }
const _hoisted_7 = { class: "space-y-0.5 text-xs" }
const _hoisted_8 = {
  key: 0,
  class: "flex justify-between gap-3"
}
const _hoisted_9 = { class: "min-w-0 break-words text-right text-catering-ink-800" }
const _hoisted_10 = {
  key: 1,
  class: "flex justify-between gap-3"
}
const _hoisted_11 = { class: "min-w-0 break-words text-right text-catering-ink-800" }
const _hoisted_12 = {
  key: 0,
  class: "mt-2 border-t border-catering-cream-300 pt-2"
}
const _hoisted_13 = { class: "mb-0.5 text-[11px] font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_14 = {
  key: 0,
  class: "space-y-0.5 text-xs"
}
const _hoisted_15 = { class: "shrink-0 text-catering-ink-500" }
const _hoisted_16 = { class: "min-w-0 break-words text-right text-catering-ink-800" }
const _hoisted_17 = {
  key: 1,
  class: "break-words text-xs text-catering-ink-800"
}
const _hoisted_18 = {
  key: 1,
  class: "mt-1 text-xs text-catering-ink-500"
}
const _hoisted_19 = {
  key: 2,
  class: "mt-2 text-[11px] text-catering-ink-500"
}

import { computed } from 'vue'

import { addressDisplayFields } from '@/helpers/botAddressFields'


export default {
  __name: 'BotCustomerContact',
  props: { block: { type: Object, required: true } },
  setup(__props) {

const props = __props

const address = computed(() => props.block.address || {})
const fields = computed(() => addressDisplayFields(props.block.address))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Contact", -1)),
    (__props.block.found === false)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.block.message || `No contact matching '${__props.block.customer}' in your contacts.`), 1))
      : (__props.block.ambiguous)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(__props.block.match_count) + " " + _toDisplayString(__props.block.match_count === 1 ? 'match' : 'matches'), 1)
            ]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.block.message || `More than one contact matches '${__props.block.customer}' - please be more specific.`), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.block.name), 1),
            _createElementVNode("dl", _hoisted_7, [
              (__props.block.phone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "shrink-0 text-catering-ink-500" }, "Phone", -1)),
                    _createElementVNode("dd", _hoisted_9, _toDisplayString(__props.block.phone), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.block.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "shrink-0 text-catering-ink-500" }, "Email", -1)),
                    _createElementVNode("dd", _hoisted_11, _toDisplayString(__props.block.email), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (__props.block.has_address)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(__props.block.address_is_default ? 'Default address' : 'Saved address'), 1),
                  (fields.value.length)
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (f) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: f.label,
                            class: "flex justify-between gap-3"
                          }, [
                            _createElementVNode("dt", _hoisted_15, _toDisplayString(f.label), 1),
                            _createElementVNode("dd", _hoisted_16, _toDisplayString(f.value), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(address.value.single_line), 1))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_18, "No saved address.")),
            (__props.block.note)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(__props.block.note), 1))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}
}

}